module.exports = __webpack_public_path__ + "img/d366b23.webp";